Object.defineProperty(exports, '__esModule', { value: true });

var ModalStore = /** @class */ (function () {
    function ModalStore() {
        var _this = this;
        this.getRestoreStyles = function () { return _this.restoreStyles; };
        this.restoreStyles = [];
    }
    return ModalStore;
}());

exports.ModalStore = ModalStore;
